// =============================================================================
// DomainRow — sekcja „Domena": gdzie wskazuje domena + przyciski cutover/rollback
// (faza 3, zablokowane). Zastepuje dwa LockedStep z dawnego MigrationPanel.
// =============================================================================

import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { Globe, Undo2, Lock } from "lucide-react";
import type { StaticSiteRow } from "@/services/staticSite/types";
import { StudioSection } from "./StudioSection";

export function DomainRow({ site }: { site: StaticSiteRow }) {
  const live = site.status === "live";
  const summary = (
    <span className="text-xs">
      <span className="font-mono">{site.domain}</span>{" "}
      {live ? <span className="text-emerald-600 dark:text-emerald-400">wskazuje na Cloudflare Pages (LIVE{site.cutover_at ? ` od ${new Date(site.cutover_at).toLocaleDateString("pl-PL")}` : ""})</span> : <span className="text-muted-foreground">wskazuje na WordPress — strona statyczna działa tylko pod adresem testowym</span>}
    </span>
  );
  const locked = (label: string, icon: React.ReactNode) => (
    <Tooltip>
      <TooltipTrigger asChild>
        <span><Button size="sm" variant="outline" disabled>{icon} {label} <Lock className="ml-1 h-3 w-3 opacity-60" /></Button></span>
      </TooltipTrigger>
      <TooltipContent side="bottom" className="max-w-xs text-xs">Faza 3: dodaje domenę do projektu Pages i zmienia rekordy DNS w Cloudflare (snapshot + rollback). Wymaga przepisania nazwy domeny. Odblokowane po zaakceptowaniu strony na adresie testowym.</TooltipContent>
    </Tooltip>
  );
  return (
    <StudioSection
      icon={Globe}
      title="Domena"
      help="Deploy trafia na *.pages.dev. Dopiero przełączenie domeny (faza 3) kieruje ruch na nową stronę; rollback cofa rekordy DNS."
      summary={summary}
      actions={<>{locked("Przełącz domenę", <Globe className="mr-1 h-3.5 w-3.5" />)}{locked("Rollback", <Undo2 className="mr-1 h-3.5 w-3.5" />)}</>}
    />
  );
}
